import ApiService from "./api.service";

const Schedule = {
    create: async function ({date, user_id, hours, place, notice}) {
        let response = await ApiService.post("/schedules", {date, user_id, hours, place, notice}, "Selected day data has been added");
        return response.data;
    },
    update: async function (day_id, {hours, place, notice}) {
        let response = await ApiService.put("/schedules/" + day_id, {hours, place, notice}, "Selected day has been updated");
        return response.data;
    },
    delete: async function (day_id) {
        await ApiService.delete("/schedules/" + day_id, {}, "Schedule data of selected day has been deleted");
        return true;
    },
    getByDate: async function (user_id, from, to) {
        let queryGet = `${user_id}?from=${from}&to=${to}`;
        let response = await ApiService.get("/schedules/users/"+queryGet);
        return response.data.items;
    },
    download: async function (user_id, from, to) {
        let queryGet = `${user_id}/pdf?from=${from}&to=${to}`;
        return ApiService.customRequest({
            method: "get",
            url: "/schedules/users/" + queryGet,
            responseType: "blob",
        });
    },

};

export default Schedule;
